'use strict';

(function () {
  'use strict';

  angular.module('msSleep').component('msSimpleWeeklyCheckin', {
    templateUrl: 'sleep/templates/simple-weekly-checkin.html',
    controller: SimpleWeeklyCheckinCtrl,
    bindings: {
      checkIn: '<',
      onContinue: '&'
    }
  });
  SimpleWeeklyCheckinCtrl.$inject = ['actionPlanSvc', 'NotifyingSvc', 'sleepCheckInSvc', 'eventTrackingSvc'];

  function SimpleWeeklyCheckinCtrl(actionPlanSvc, NotifyingSvc, sleepCheckInSvc, eventTrackingSvc) {
    var vm = this;
    vm.removeActionItem = removeActionItem;
    vm.addActionItem = addActionItem;
    vm.saveCheckin = saveCheckin;
    vm.openTipModal = openTipModal;

    activate();

    ///////////////////////////////
    function activate() {
      actionPlanSvc.getMyPlan().then(function (actionItems) {
        vm.actionItems = actionItems;
      });
    }

    function removeActionItem(actionItem) {
      actionPlanSvc.removeFromPlan(actionItem.id).then(function () {
        actionItem.deleted = true;
        actionItem.success = undefined;
      });
    }

    function addActionItem(actionItem) {
      actionPlanSvc.addToPlan(actionItem.id).then(function () {
        actionItem.deleted = false;
      });
    }

    function saveCheckin() {
      //augment an incoming check-in if necessary, else create a new one
      var checkIn = vm.checkIn || {};
      checkIn.checkInStatus = 'COMPLETE';
      checkIn.actionItems = vm.actionItems.filter(function (ai) {
        return !ai.deleted && !_.isUndefined(ai.success);
      }).map(function (ai) {
        return {
          actionItemId: ai.id,
          success: ai.success
        };
      });

      eventTrackingSvc.fireEvent('sleepTool', 'weeklyCheckin', 'actionItemCheckin');
      sleepCheckInSvc.saveCheckIn(checkIn).then(function () {
        if (_.isFunction(vm.onContinue)) {
          vm.onContinue();
        }
      });
    }

    function openTipModal(actionItem) {
      var tip = _.sample(actionItem.tips);
      NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.OPEN_MODAL, {
        controller: ['close', 'tip', function (close, tip) {
          this.tip = tip;
          this.closeModal = close;
        }],
        templateUrl: 'sleep/templates/sleep-tip-detail.html',
        inputs: {
          tip: tip
        }
      });
    }
  }
})();